import { useEffect, useState } from "react";

function getWindowSize() {
  if (typeof window === "undefined") {
    return {
      width: 0,
      height: 0,
    };
  }

  const { hostname, search } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const uiViewport = new URLSearchParams(search).get("uiViewport");
    if (uiViewport === "mobile") {
      return { width: 390, height: 844 };
    }
    if (uiViewport === "desktop") {
      return { width: 1280, height: 900 };
    }
  }

  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getWindowSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
